// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$('#privary-navigation li').each(function( index ) {
			if($( this ).children('.submenu').length > 0) {
				$(this).addClass('dropdown');
			}
		});
		$('.text-modules ').children().each(function () {
			$(this).addClass('animate-fade top');

		});

		$('.burger').click(function(e) {
			e.preventDefault();
			$('.header').toggleClass('open');
		});

		if(document.getElementsByClassName('lightbox').length > 0){
			let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
			let allLightboxesLength = allLightboxes.length;
	
			for(let j = 0; j < allLightboxesLength; j++ ){
				allLightboxes[j].addEventListener('click', function(e){
					e.preventDefault();
					let currentTarget = this.getAttribute('data-id').split('#')[1];
					if(!document.getElementById(currentTarget).classList.contains('open')){
						document.getElementById(currentTarget).classList.add('open')
					} else {
						document.getElementById(currentTarget).classList.remove('open')
					}
				});
			}
	
			let allLightcloses = document.getElementsByClassName('js-lightboxclose');
			let allLightclosesLength = allLightcloses.length;
	
			for(let j = 0; j < allLightclosesLength; j++ ){
				allLightcloses[j].addEventListener('click', function(e){
					e.preventDefault();
					let currentTarget = this.parentElement.parentElement.id;
					if(!document.getElementById(currentTarget).classList.contains('open')){
						document.getElementById(currentTarget).classList.remove('open')
					} else {
						document.getElementById(currentTarget).classList.add('open')
					}
				});
			}
		}
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}